import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'high-level-significant-legend-svg',
  templateUrl: './high_level_significant_legend.svg',
  styleUrl: './high-level-significant-legend-svg.css',
  standalone: true,
  imports: [CommonModule]
})
export class HighLevelSignificantSvgComponent {}
